document.addEventListener('DOMContentLoaded', function() {
  var custom_recently_viewed = document.getElementsByClassName("custom-recently-viewed-products");
  if (!custom_recently_viewed.length) return;
  
  const productData = JSON.parse(localStorage.getItem("recentlyViewedProduct"));
  if (!productData || productData.length === 0) {
    Array.from(custom_recently_viewed).forEach(function (el) { el.style.display = 'none'; });
    return;
  }

  var number_of_items = parseInt(custom_recently_viewed[0].dataset.number_of_items || 8);
  var recentlyViewedHtml = '';
  var recentlyViewedProductsObj = {};
  var itemsDone = 0;
  
  // We want up to number_of_items. Reverse it so the most recent is first.
  var data = productData.reverse().slice(0, number_of_items);
  
  Array.from(data).forEach(function (product, index, array) {
    fetch(product.productUrl + '/?section_id=custom-product-item')
      .then((response) => response.text())
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').getElementById('shopify-section-custom-product-item').innerHTML;
        recentlyViewedProductsObj[product.productId] = resultsMarkup;
        itemsDone++;
        
        if (itemsDone === array.length){
          Array.from(data).forEach(function (prod) {
            recentlyViewedHtml += recentlyViewedProductsObj[prod.productId];
          });
          
          Array.from(custom_recently_viewed).forEach(function (el) {
            var scroll_container = el.querySelector('.cpb-horizontal-scroll');
            if(scroll_container) {
               scroll_container.innerHTML = recentlyViewedHtml;
            }
          });
        }
      })
      .catch(e => console.error(e));
  });
});
